var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomCodeP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5C4.34315 5 3 6.34315 3 8V22C3 23.6569 4.34315 25 6 25H24C25.6569 25 27 23.6569 27 22V8C27 6.34315 25.6569 5 24 5H6ZM11.5 15C11.5 15.8284 10.8284 16.5 10 16.5C9.17157 16.5 8.5 15.8284 8.5 15C8.5 14.1716 9.17157 13.5 10 13.5C10.8284 13.5 11.5 14.1716 11.5 15ZM15 16.5C15.8284 16.5 16.5 15.8284 16.5 15C16.5 14.1716 15.8284 13.5 15 13.5C14.1716 13.5 13.5 14.1716 13.5 15C13.5 15.8284 14.1716 16.5 15 16.5ZM20 16.5C20.8284 16.5 21.5 15.8284 21.5 15C21.5 14.1716 20.8284 13.5 20 13.5C19.1716 13.5 18.5 14.1716 18.5 15C18.5 15.8284 19.1716 16.5 20 16.5Z",
    fill: "#533EAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCodeP);
export default __webpack_public_path__ + "static/media/custom_code_p.841764430103982e997527e9ad878dcd.svg";
export { ForwardRef as ReactComponent };